import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import api from '../../lib/api';
import { useText } from '../../lib/siteContent';

const Testimonials = () => {
  const [items, setItems] = useState([]);
  const t = useText();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/testimonials');
        setItems(data);
      } catch {
        setItems([]);
      }
    })();
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="py-32 bg-[#FFFFFF] text-[#111111] relative overflow-hidden border-t border-[#111111]/10">

      <div className="container-custom relative z-10">
        <div className="text-center mb-24">
          <span className="text-xs uppercase tracking-[0.4em] text-[#111111] mb-4 block">{t('testimonials.label')}</span>
          <h2 className="text-4xl md:text-6xl font-serif">{t('testimonials.title')}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-24">
          {items.map((item) => (
            <div key={item.id} className="relative group">
              <div className="text-[#111111]/30 mb-8 transform group-hover:scale-110 transition-transform duration-500 origin-left">
                {Array.from({ length: item.rating || 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 inline-block mx-1" fill="#111111" />
                ))}
              </div>
              <p className="text-[#111111]/80 text-lg leading-relaxed mb-8 font-serif italic font-light opacity-60 group-hover:opacity-100 transition-opacity duration-500">
                "{item.text}"
              </p>
              <div className="border-t border-[#111111]/10 pt-6">
                <p className="font-bold text-[#111111] text-xs uppercase tracking-[0.2em] mb-2">{item.author}</p>
                {item.event && <p className="text-xs text-[#111111]/40">{item.event}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
